import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import EventCardListing from './EventCardListing'
import EventCardForm from './EventCardForm'

const EventCards = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <EventCardListing />
      </Route>
      <Route path={`${path}/new`}>
        <EventCardForm displayContext="page" />
      </Route>
      <Route path={`${path}/edit/:iconId`}>
        <EventCardForm displayContext="page" />
      </Route>
    </Switch>
  )
}

export default EventCards
